import type { MoneyHalalas } from "@sirdab/returns-shared";
import { cn } from "@sirdab/ui";

import { formatMoney } from "../format/money";
import { useMessages } from "../i18n";

export interface MoneyProps {
  /** Integer halalas, exactly as it arrives on the wire. Never a float. */
  halalas: MoneyHalalas;
  className?: string;
}

/**
 * The ONLY place currency reaches the screen. Every fee, unit price and line total goes
 * through here, and here goes through foundation's `formatPrice`, so Saudi currency
 * presentation is decided once for the whole monorepo.
 *
 * `dir="ltr"` on the number itself: a currency amount is a bidi-neutral run, and letting it
 * inherit RTL is how a price ends up reordered mid-sentence.
 */
export function Money({ halalas, className }: MoneyProps): React.JSX.Element {
  const { locale } = useMessages();
  return (
    <span dir="ltr" className={cn("tabular whitespace-nowrap", className)}>
      {formatMoney(halalas, locale)}
    </span>
  );
}
